import axios from "axios"
import { Fragment, useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { ErrorModal } from "."
import Input from "react-phone-number-input/input"
import { isValidPhoneNumber } from "react-phone-number-input"
import BusVendorDropdown from "../BusDropdown/BusVendorDropdown"
import BusPlateNumberDropdown from "../BusDropdown/BusPlateNumberDropdown"
import NumberFormat from 'react-number-format'

const CreateUserForm = () => {
    const [form, setForm] = useState({
        name: '', 
        phoneNo: '', 
        icNo: '',
        busVendor: '',
        busPlateNo: ''
    })
    const [errors, setErrors] = useState({})

    const [buses, setBuses] = useState([])
    const [busVendorID, setBusVendorID] = useState()
    const [busVendorLabel, setBusVendorLabel] = useState()
    const [busPlateNoID, setBusPlateNoID] = useState()
    const [busPlateNoLabel, setBusPlateNoLabel] = useState()

    const [errorMessage, setErrorMessage] = useState()
    const [showErrorModal, setShowErrorModal] = useState(false)

    const handleShowErrorModal = () => setShowErrorModal(!showErrorModal)

    const [clearSelect, setClearSelect] = useState(false)

    const { REACT_APP_API_BACKEND_URL } = process.env;

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
          // Check and see if errors exist, and remove them from the error object:
        if ( !!errors[field] ) setErrors({
            ...errors,
            [field]: null
        })
    }

    const findFormErrors = () => {
        const { phoneNo, icNo } = form
        const newErrors = {}

        // phone number error
        if (phoneNo && !isValidPhoneNumber(form.phoneNo)) newErrors.phoneNo = 'Invalid phone number!'

        // ic no error
        if (icNo.length < 12) newErrors.icNo = 'Not a valid IC number!'

        return newErrors
    }
    
    const createUser = () => {
        const url = '../../create_user.php'
        const busPlateNo = (busVendorLabel === 'Vaccination Centre' || busVendorLabel === 'Vaccine') ?
        null : busPlateNoLabel

        axios.post(url, {
            name: form.name,
            phoneNo: form.phoneNo,
            icNo: form.icNo,
            busVendor: busVendorLabel,
            busPlateNumber: busPlateNo
        }, { 
            headers: { 'content-type': 'application/json' }
        })
        .then(result => {
            // console.log(result)
        })
        .catch(error => {
            console.log(error)
        })
    }

    const postToAPI = () => {
        const url = REACT_APP_API_BACKEND_URL + '/api/busdriver/registerbusdriver';
        // const busPlateWithLabel = (busVendorLabel === 'Vaccination Centre' || busVendorLabel === 'Vaccine') ?
        // null : busPlateNoLabel
        // const busPlateWithID = (busVendorLabel === 'Vaccination Centre' || busVendorLabel === 'Vaccine') ?
        // null : busPlateNoID
        const formattedUsername = form.phoneNo.slice(2)
        const formattedPhoneNo = form.phoneNo.slice(1)
        
        const busDriverDetails = {
            username: formattedUsername,
            contact_number: formattedPhoneNo,
            bus_plate_number: busPlateNoLabel,
            fullname: form.name,
            nric: form.icNo,
            is_active: true,
            vendor: busVendorID,
            bus: busPlateNoID
        }

        axios.post(url, busDriverDetails)
        .then(res => {
            setClearSelect(true)
            setBusVendorID('')
            const successResponse = res.data.Result.message.includes("Successful Created.") || res.data.Result.message.includes("Successful activate user.")
            const userExistsException = res.data.Result.message.includes("Username / NRIC existed.")
            const message = successResponse ? 
            ("User has been successfully created!") :
            userExistsException ? 
            "Username / NRIC existed."
            : "System has encountered an error."
            
            if (successResponse) {
                createUser()
            }
            setErrorMessage(message)
            setShowErrorModal(!showErrorModal)
        })
        .catch(err => {
            setClearSelect(true)
            setBusVendorID('')
            if (err.toJSON().message === 'Network Error') {
                alert('Please check your internet connection!');
            } else {
                console.log(err)
            }
        })
        .then(() => {
            setClearSelect(false)
        })
    }

    const getBusVendor = (busVendorProp) => {
        setField('busVendor', busVendorProp);

        if (busVendorProp) {
            // To check if the bus vendor has buses
            if (busVendorProp.buses.length > 0) {
                setBusVendorID(busVendorProp.value)
                setBusVendorLabel(busVendorProp.label)
                setBuses(busVendorProp.buses)
            } else {
                setBusVendorID(busVendorProp.value)
                setBusVendorLabel(busVendorProp.label)
                setBuses(busVendorProp.buses)
                setBusPlateNoID(null)
                setBusPlateNoLabel(null)
            }
        }
    }

    const getBusPlateNo = (busPlateNoProp) => {
        setField('busPlateNo', busPlateNoProp)

        if (busPlateNoProp) {
            setBusPlateNoID(busPlateNoProp.value)
            setBusPlateNoLabel(busPlateNoProp.label)
        }
    }

    const onSubmit = (e) => {
        e.preventDefault();

        const newErrors = form && findFormErrors();

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors)
        } else {
            // createUser(form)
            postToAPI()
            setForm({ name: '', phoneNo: '', icNo: '', busVendor: '', busPlateNo: '' })
        }
    };

    const noop = () => {
        // no operation (do nothing real quick)
    };

    const getVendorValue = () => {
        if (form.busVendor !== undefined) return form.busVendor;
        return form.busVendor || "";
    };

    const getPlateNoValue = () => {
        if (form.busPlateNo !== undefined) return form.busPlateNo;
        return form.busPlateNo || "";
    };

    const handleICChange = (values) => {
        const { value } = values;
        // formattedValue = 123456-10-1234
        // value = 123456101234
        setField('icNo', value)
    }
    
    return (
        <Fragment>
            <Form style={{margin: '20px 50px'}} onSubmit={onSubmit}>
                <h4 className='mt-5 mb-4 fw-bold'>Create Bus Driver Form</h4>
                <Form.Group as={Row} className='mb-3'>
                    <Form.Label className='fw-bold' column sm='4'>
                        Name
                    </Form.Label>
                    <Col sm='6'>
                        <Form.Control 
                            type='text' 
                            placeholder='Enter Name' 
                            value={form.name}
                            onChange={(e) => setField('name', e.target.value)}
                            isInvalid={ !!errors.name }
                            required 
                        />
                        <Form.Control.Feedback type='invalid'>
                            { errors.name }
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className='mb-3'>
                    <Form.Label className='fw-bold' column sm='4'>
                        Phone Number
                    </Form.Label>
                    <Col sm='6'>
                        <Input
                            placeholder="e.g. 01# ########"
                            country='MY'
                            value={form.phoneNo}
                            onChange={(e) => setField('phoneNo', e)}
                            className={`${errors.phoneNo ? 'form-control is-invalid' : 'form-control'}`}
                            required
                        />
                        {errors.phoneNo &&
                            <div className='invalid-feedback'>{errors.phoneNo}</div>
                        }
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className='mb-3'>
                    <Form.Label className='fw-bold' column sm='4'>
                        IC Number
                    </Form.Label>
                    <Col sm='6'>
                        <NumberFormat
                            placeholder='Enter IC Number'
                            format='######-##-####'
                            mask='_'
                            value={form.icNo}
                            onValueChange={handleICChange}
                            className={`${errors.icNo ? 'form-control is-invalid' : 'form-control'}`}
                            required
                        />
                        {/* <Form.Control 
                            type='text'
                            placeholder='Enter IC Number'
                            value={form.icNo}
                            onChange={(e) => setField('icNo', e.target.value)}
                            isInvalid={ !!errors.icNo }
                            required 
                        /> */}
                        <Form.Control.Feedback type='invalid'>
                            { errors.icNo }
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className='mb-3'>
                    <Form.Label className='fw-bold' column sm='4'>
                        Bus Vendor
                    </Form.Label>
                    <Col sm='6'>
                        <BusVendorDropdown 
                            getBusVendor={getBusVendor}
                            clearSelect={clearSelect}
                        />
                        {(form.busVendor === '' || form.busVendor === null) &&
                            <input
                                tabIndex={-1}
                                autoComplete="off"
                                style={{
                                    opacity: 0,
                                    width: "100%",
                                    height: 0,
                                    position: "absolute"
                                }}
                                value={getVendorValue}
                                onChange={noop}
                                required
                            />
                        }
                    </Col>
                </Form.Group>
                {(busVendorID && buses.length > 0) &&
                    <Form.Group as={Row} className='mb-3'>
                        <Form.Label className='fw-bold' column sm='4'>
                            Bus Plate Number
                        </Form.Label>
                        <Col sm='6'>
                            <BusPlateNumberDropdown
                                busVendor={form.busVendor}
                                busVendorID={busVendorID} 
                                getBusPlateNo={getBusPlateNo}
                                clearSelect={clearSelect}
                            />
                            {(form.busPlateNo === '' || form.busPlateNo === null) &&
                            <input
                                tabIndex={-1}
                                autoComplete="off"
                                style={{
                                    opacity: 0,
                                    width: "100%",
                                    height: 0,
                                    position: "absolute"
                                }}
                                value={getPlateNoValue}
                                onChange={noop}
                                required
                            />
                            }
                        </Col>
                    </Form.Group>
                }
                <Button as="input" type="submit" value="Submit" />
            </Form>
            {
                showErrorModal && 
                <ErrorModal message={errorMessage} show={showErrorModal} handleClose={handleShowErrorModal} />
            }
        </Fragment>
    )
}

export default CreateUserForm
